var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTop2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4800_4204)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1912 0H28.8232L20.8158 10.2194H11.1838L19.1912 0Z",
    fill: "#F9DD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1912 0H23.2618L15.2545 10.2194H11.1838L19.1912 0Z",
    fill: "#6FC0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3047 0H25.7101L17.7027 10.2194H14.2974L22.3047 0Z",
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0001 32C21.5098 32 25.9763 27.5335 25.9763 22.0238C25.9763 16.5141 21.5098 12.0476 16.0001 12.0476C10.4904 12.0476 6.02393 16.5141 6.02393 22.0238C6.02393 27.5335 10.4904 32 16.0001 32Z",
    fill: "#CBD2D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1841 13.2855V10.2194H20.8161V13.2855L22.4488 14.412V9.40298C22.4488 8.95236 22.0837 8.58667 21.6325 8.58667H10.3678C9.9172 8.58667 9.55151 8.95236 9.55151 9.40298V14.4126L11.1841 13.2855Z",
    fill: "#E3E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 29.4923C20.1246 29.4923 23.4684 26.1486 23.4684 22.0239C23.4684 17.8992 20.1246 14.5554 15.9999 14.5554C11.8752 14.5554 8.53149 17.8992 8.53149 22.0239C8.53149 26.1486 11.8752 29.4923 15.9999 29.4923Z",
    fill: "#E3E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8088 0H3.17676L11.1841 10.2194H20.8161L12.8088 0Z",
    fill: "#6FC0F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8088 0H8.73804L16.7454 10.2194H20.8161L12.8088 0Z",
    fill: "#F9DD40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.69541 0H6.29004L14.2974 10.2194H17.7027L9.69541 0Z",
    fill: "#FF6C00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2049 16.4163C17.8723 16.4163 19.281 17.5519 19.281 19.2768C19.281 22.3673 14.6237 23.3735 14.6237 25.0266V25.5728H18.8497C19.1084 25.5728 19.3528 25.8747 19.3528 26.2341C19.3528 26.5934 19.1084 26.924 18.8497 26.924H13.7324C13.4449 26.924 13.0569 26.7228 13.0569 26.4209V25.0265C13.0569 22.6979 17.7574 21.5336 17.7574 19.3199C17.7574 18.6156 17.2974 17.8106 16.205 17.8106C15.4001 17.8106 14.7532 18.2561 14.7532 19.2336C14.7532 19.5211 14.4513 19.8086 13.9483 19.8086C13.5458 19.8086 13.2583 19.6074 13.2583 18.9606C13.2581 17.4225 14.6381 16.4163 16.2049 16.4163Z",
    fill: "#7F8389"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4800_4204"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTop2);
export default __webpack_public_path__ + "static/media/top2.61706f9eee463a9a22c11cb49942dd3b.svg";
export { ForwardRef as ReactComponent };